import { ConfigValueCustomField } from 'src/typings/kenai/configuration/custom-fields'

export function withInputType(customFields: Omit<ConfigValueCustomField, 'inputType'>[]) {
  return customFields.map((field) => ({
    ...field,
    inputType: field.inputSettings.inputType as any, // fake it till you make it :)
  })) as ConfigValueCustomField[]
}
